module.exports = __webpack_public_path__ + "img/xiaozhi_logo2.197817e7.png";